import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { AcademicTerm } from '../types';
import { getAcademicTermColumns } from '../utils/academicTermColumns';
import pallet from '../../../layouts/pallet';
import { StyledButton } from '../../Exams/styled';
import { dataGridSx } from '../../common/styled/DataGrid';
import Icons from '../../../components/icons';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';

interface AcademicTermsTableAndActionsProps {
  onEdit: (academicTerm: AcademicTerm) => void;
  onDelete: (academicTerm: AcademicTerm) => void;
  onAddAcademicTerm: (value: boolean) => void;
  academicTerms: AcademicTerm[];
  isLoading: boolean;
}

const AcademicTermsTableAndActions: React.FC<
  AcademicTermsTableAndActionsProps
> = ({ onEdit, onDelete, onAddAcademicTerm, academicTerms, isLoading }) => {
  const columns = getAcademicTermColumns(onEdit, onDelete);

  return (
    <PageWrapper sx={{ paddingTop: '16px !important' }}>
      <StyledButton
        onClick={() => onAddAcademicTerm(true)}
        sx={{ width: 'max-content', alignSelf: 'flex-end' }}
      >
        <Icons.PlusWhite style={{ marginRight: '6px' }} /> Add Term
      </StyledButton>
      <DataGrid
        rowHeight={50}
        rows={academicTerms}
        columns={columns}
        loading={isLoading}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={{
          ...tableColumnUtils.DATA_GRID_INITIAL_STATE,
          columns: {
            ...columns,
            columnVisibilityModel: { id: false }
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default AcademicTermsTableAndActions;
